import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import DashboardService from "./DashboardService";
import { DataForm } from "../../../libs/react-mpk/components";
import moment from "moment";

import {
  SortOrder,
  TableContainer,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  TableBody,
  Caption,
} from "@react-md/table";
import { FontIcon } from "@react-md/icon";
import {
  AppBar,
  AppBarNav,
  AppBarTitle,
  AppBarAction,
} from "@react-md/app-bar";
import { useState } from "react";
import { Line, Circle } from "rc-progress";
import Utils from "../../../libs/custom/Utils";

function SummaryPpnDashboardView({ sipStore }) {
  const [data, setData] = useState({
    loading: true,
    content: [],
    sortKey: "nama",
    sortOrder: "ascending",
    total: 0,
    param: {},
  });

  const [toggleFilter, setToggleFilter] = useState(false);

  useEffect(() => {
    initData("nama", {
      perusahaanId: sipStore.companyId,
      "tahun.equals": "" + sipStore.periode.tahun,
      "bulan.greaterThanOrEqual": "1",
      "bulan.lowerThanOrEqual": "12",
    });
  }, []);

  async function initData(sortKey, param) {
    var d = data.content;
    if (param) {
      param.pageSize = 10000000000;
      delete param.tahun;
      var pph21 = await DashboardService.pelaporanPpn(param);

      d = pph21.data;
    }

    setData((prevState) => {
      const prevSortKey = prevState.sortKey;
      const prevSortOrder = prevState.sortOrder;

      let sortOrder;
      if (sortKey === prevSortKey) {
        // it's the same column, so toggle the sort order
        sortOrder = prevSortOrder === "ascending" ? "descending" : "ascending";
      } else {
        // it's a new column to sort by, so default to ascending for the name column
        // but descending for all the rest.
        sortOrder = sortKey === "name" ? "ascending" : "descending";
      }

      return {
        content: d.sort((a, b) => {
          const aValue = a[sortKey];
          const bValue = b[sortKey];
          const value =
            typeof aValue === "number"
              ? aValue - bValue
              : "" + aValue.localeCompare(bValue);
          return value * (sortOrder === "ascending" ? 1 : -1);
        }),
        sortKey,
        sortOrder,
        param,
        loading: false,
        total: d.reduce((pv, cv) => {
          pv = pv + cv.totalPph;
          return pv;
        }, 0),
      };
    });
  }

  const { content, sortKey, sortOrder } = data;

  return (
    <div
      className="mpk-form-wrapper mpk-paper  padding-all mpk-animation slide-in"
      style={{
        width: "100%",
        maxWidth: 1200,
        margin: "0px auto",
      }}
    >
      <AppBar theme="clear">
        <AppBarTitle className="rmd-typography--capitalize">
          {/* PELAPORAN */}
        </AppBarTitle>

        <AppBarAction
          first
          aria-label="Actions"
          onClick={() => {
            setToggleFilter(!toggleFilter);
          }}
        >
          <FontIcon iconClassName="mdi mdi-filter" />
        </AppBarAction>
      </AppBar>
      <div className="mpk-padding-N" style={{ height: 600, overflow: "auto" }}>
        {toggleFilter && (
          <DataForm
            baseId={"pegawai-import"}
            // asDialog={true}
            defaultData={data.param}
            definitions={[
              {
                inputType: DataForm.inputTypes.INPUT,
                label: "Tahun Pajak",
                key: "tahun.equals",
                theme: "filled",
                validation: "required",
                width: "49%",
                style: { marginRight: "2%", width: "100%" },
              },
              {
                inputType: DataForm.inputTypes.SELECT,
                label: "Masa Pajak Dari",
                key: "bulan.greaterThanOrEqual",
                type: "text",
                style: { marginRight: "2%" },
                width: "49%",
                required: true,
                validation: "required",
                options: [
                  { value: "1", label: "1" },
                  { value: "2", label: "2" },
                  { value: "3", label: "3" },
                  { value: "4", label: "4" },
                  { value: "5", label: "5" },
                  { value: "6", label: "6" },
                  { value: "7", label: "7" },
                  { value: "8", label: "8" },
                  { value: "9", label: "9" },
                  { value: "10", label: "10" },
                  { value: "11", label: "11" },
                  { value: "12", label: "12" },
                ],
              },
              {
                inputType: DataForm.inputTypes.SELECT,
                label: "Masa Pajak Sampai",
                key: "bulan.lowerThanOrEqual",
                type: "text",
                width: "49%",
                required: true,
                validation: "required",
                options: [
                  { value: "1", label: "1" },
                  { value: "2", label: "2" },
                  { value: "3", label: "3" },
                  { value: "4", label: "4" },
                  { value: "5", label: "5" },
                  { value: "6", label: "6" },
                  { value: "7", label: "7" },
                  { value: "8", label: "8" },
                  { value: "9", label: "9" },
                  { value: "10", label: "10" },
                  { value: "11", label: "11" },
                  { value: "12", label: "12" },
                ],
              },
              // {
              //   inputType: DataForm.inputTypes.SELECT,
              //   label: "Kategori Pajak",
              //   key: "type",
              //   theme: "filled",
              //   validation: "required",
              //   options: [
              //     { label: "Pajak Terutang", value: "Pajak Terutang" },
              //     {
              //       label: "Pajak Dibayar Dimuka",
              //       value: "Pajak Dibayar Dimuka",
              //     },
              //   ],
              //   style: { width: "29%" },
              // },
            ]}
            // visible={uploadModal}
            submitLabel="Cari"
            onSubmit={async (d, callback) => {
              try {
                await initData(data.sortKey, {
                  ...d,
                  perusahaanId: sipStore.companyId,
                });
                callback();
              } catch (e) {
                console.log(e.response);
                callback(e.response.data.message);
              }
            }}
          />
        )}
        <TableContainer style={{ minHeight: 600 }}>
          <Table fullWidth>
            <Caption>
              {data.param["bulan.greaterThanOrEqual"]} -{" "}
              {data.param["bulan.lowerThanOrEqual"]}{" "}
              {data.param["tahun.equals"]}
            </Caption>
            <TableHeader>
              {/* <TableRow>
                <TableCell key="tahun">TAHUN</TableCell>
              </TableRow> */}
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell>
                  <div>
                    <b>TAHUN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.tahun}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>MASA</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.bulan}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>PEMBETULAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.pembetulan}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>NPWP</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.npwp}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>NAMA</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.nama}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>STATUS</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.ntte ? "SUDAH LAPOR" : "BELUM LAPOR"}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow style={{ borderTop: "2px solid black" }}>
                <TableCell>
                  <div>
                    <b>PENYERAHAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      DPP
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      PPN
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    PENYERAHAN DALAM NEGERI DENGAN FP YANG TIDAK DIGUNGGUNG
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.fpTidakDitanggung)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.fpTidakDitanggungPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>PENYERAHAN DALAM NEGERI DENGAN FP YANG DIGUNGGUNG</div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.fpDitanggung)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.fpDitanggungPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>2. PENYERAHAN YANG PPN-NYA HARUS DIPUNGUT SENDIRI</div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.dipungutSendiri)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.dipungutSendiriPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    3. PENYERAHAN YANG PPN-NYA HARUS DIPUNGUT OLEH PEMUNGUT
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.dipungutPemungut)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.dipungutPemungutPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>4. PENYERAHAN YANG PPN-NYA TIDAK DIPUNGUT</div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.tidakDipungut)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.tidakDipungutPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>5. PENYERAHAN YANG DIBEBASKAN DARI PENGENAAN PPN</div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.bebasPpn)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.bebasPpnPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>JUMLAH PENYERAHAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.jumlahPenyerahan)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.jumlahPenyerahanPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>I.B. TIDAK TERUTANG PPN</div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.tdkTerutang)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.tdkTerutangPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>C. JUMLAH SELURUH PENYERAHAN (I.A + I.B)</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.jumlahSeluruhPenyerahan)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.jumlahSeluruhPenyerahanPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    A. PAJAK KELUARAN YANG HARUS DIPUNGUT SENDIRI (JUMLAH PPN
                    PADA I.A.2)
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.pkDipungutSendiri)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.pkDipungutSendiriPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>B. PPN DISETOR DIMUKA DALAM MASA PAJAK YANG SAMA</div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.ppnDisetorDimuka)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.ppnDisetorDimukaPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>C. PAJAK MASUKKAN YANG DAPAT DIPERHITUNGKAN</div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.pm)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.pmPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    c.i. IMPOR BKP/PEMANFAATAN BKP TIDAK BERWUJUD DARI LUAR
                    DAERAH PABEAN/DAN PEMANFAAATAN JKP DARI LUAR DAERAH PABEAN
                    YANG PM-NYA DAPAT DIKREDITKAN
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.imporBkp)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.imporBkpPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    c.ii. PEROLEHAN BKP/JKP DARI DALAM NEGERI YANG PM-NYA DAPAT
                    DIKREDITKAN
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.perolehanBkp)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.perolehanBkpPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    c.iii. IMPOR ATAU PEROLEHAN YANG PM-NYA TIDAK DAPAT
                    DIKREDITKAN DAN/ATAU IMPOR ATAU PEROLEHAN YANG MENDAPAT
                    FASILITAS
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.impor)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.imporPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>
                      PAJAK MASUKAN ATAS PEROLEHAN YANG DAPAT DI KREDITKAN
                      (c.i+c.ii)
                    </b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(0)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(0)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>KOMPENSASI ATAS PAJAK MASUKAN BULAN SEBELUMNYA</div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.kompensasiPm)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.kompensasiPmPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    PENGHITUNGAN KEMBALI PAJAK MASUKAN YANG TELAH DIKREDITKAN
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.pengembalianPm)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.pengembalianPmPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>PAJAK MASUKAN YANG DAPAT DIPERHITUNGKAN</div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.pmDiperhitungkan)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.pmDiperhitungkanPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    D. PPN YANG KURANG ATAU (LEBIH) DIBAYAR (II.A-II.B-II.C)
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.kurangLebihPpn)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.kurangLebihPpnPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    E. PPN KURANG ATAU (LEBIH) DIBAYAR PADA SPT YANG DIBETULKAN
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.kurangLebihPpnPembetulan)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.kurangLebihPpnPembetulanPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>
                      F. PPN KURANG ATAU (LEBIH) BAYAR KARENA PEMBETULAN
                      (II.D-II.E)
                    </b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200 }}>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.ppnKurangKarenaPembetulan)}
                    </div>
                    <div
                      style={{
                        width: "50%",
                        float: "left",
                        textAlign: "right",
                      }}
                    >
                      {Utils.numberFormat(v.ppnKurangKarenaPembetulanPpn)}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default inject(
  "sipStore",
  "authStore"
)(observer(SummaryPpnDashboardView));

const colors = [
  "#ef5350",
  "#ff1744",
  "#ec407a",
  "#f50057",
  "#ab47bc",
  "#d500f9",
  "#7e57c2",
  "#651fff",
  "#5c6bc0",
  "#3d5afe",
  "#42a5f5",
  "#2979ff",
  "#29b6f6",
  "#00b0ff",
  "#26c6da",
  "#00e5ff",
  "#26a69a",
  "#1de9b6",
  "#66bb6a",
  "#00e676",
  "#9ccc65",
  "#76ff03",
  "#d4e157",
  "#c6ff00",
  "#ffee58",
  "#ffea00",
  "#ffca28",
  "#ffc400",
  "#ffa726",
  "#ff9100",
  "#ff7043",
  "#ff3d00",
  "#8d6e63",
  "#bdbdbd",
  "#78909c",
];

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
